import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class Logger {
  debug(message: string, ...optionalParams: unknown[]) {
    if (environment.debug) {
      console.debug(message, ...optionalParams);
    }
  }

  info(message: string, ...optionalParams: unknown[]) {
    if (environment.debug) {
      console.info(message, ...optionalParams);
    }
  }

  warn(message: string, ...optionalParams: unknown[]) {
    console.warn(`[WARNING] ${message}`, ...optionalParams);
  }

  error(message: string, error?: unknown, ...optionalParams: unknown[]) {
    console.error(`[ERROR] ${message}`, error, ...optionalParams);

    // You could add error reporting service integration here
    // this.errorReportingService.report(error);
  }

  trace(message: unknown, ...optionalParams: unknown[]) {
    if (environment.debug) {
      console.trace(`[TRACE] ${message}`, ...optionalParams);
    }
  }

  group(label: string): void {
    if (environment.debug) {
      console.group(label);
    }
  }

  groupEnd(): void {
    if (environment.debug) {
      console.groupEnd();
    }
  }

  // Performance monitoring
  time(label: string): void {
    if (environment.debug) {
      console.time(label);
    }
  }

  timeEnd(label: string): void {
    if (environment.debug) {
      console.timeEnd(label);
    }
  }
}
